import { LIMIT } from '@/constants';
import { Sort, type AnyObj } from '@/types';
import {
  fetchSubscriptionsDetailsDocument,
  fetchSubscriptionsDocument,
  fetchUpdateSubscriptionAddressDocument,
  fetchUpdateSubscriptionFrequencyDocument,
} from '../graphql/docs';
import { fetcher } from '../graphql/fetcher/index';

/**
 * 获取订阅列表
 * @param skip - 数据略过个数
 */
export const fetchSubscriptionsList = async (skip: number, filterState: AnyObj, take?: number) => {
  const res = await fetcher.query(fetchSubscriptionsDocument, {
    variables: {
      options: {
        take: take ?? LIMIT,
        skip: LIMIT * skip,
        filter: {
          state: filterState,
        },
        sort: {
          createdAt: Sort.DESC,
        },
      },
    },
  });
  return res.data.value?.subscriptions?.items;
};

/**
 * 获取订阅详情
 * @param id - 订阅id
 */
export const fetchSubscriptionDetails = async (subscriptionId: string) => {
  const res = await fetcher.query(fetchSubscriptionsDetailsDocument, {
    variables: {
      subscriptionId,
    },
  });
  return res.data.value?.subscription;
};

/**
 * 修改订阅周期
 * @param frequency
 * @param subscriptionId
 */
export const fetchUpdateSubscriptionFrequency = async (
  frequency: number,
  subscriptionId: string
) => {
  const res = await fetcher.mutation(fetchUpdateSubscriptionFrequencyDocument, {
    frequency,
    subscriptionId,
  });
  return res.data?.updateSubscriptionFrequency;
};

/**
 * 修改订阅地址
 * @param input
 * @param subscriptionId
 * @returns
 */
export const fetchUpdateSubscriptionAddress = async (input: AnyObj, subscriptionId: string) => {
  delete input.id;
  delete input.createdAt;
  delete input.updatedAt;
  delete input.country;
  const res = await fetcher.mutation(fetchUpdateSubscriptionAddressDocument, {
    input: {
      ...input,
      countryCode: 'CN',
    },
    subscriptionId,
  });
  return res.data?.updateSubscriptionAddress;
};
